import type { GoalFormModel } from "web_myplann/Goals/Forms/useGoalForm";
import { mapGoalFormToRequest } from "web_myplann/Goals/Mappers/mapGoalFormToRequest";
import type { UpdateGoalRequestDTO } from "web_myplann/Infrastructure/Api/Api";

export const mapGoalFormToUpdateRequest = (
	data: GoalFormModel,
): UpdateGoalRequestDTO => mapGoalFormToRequest(data);
